module.exports = __webpack_public_path__ + "img/xo.4c0335b1.jpeg";